import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { ScreenProps } from '../../types/ptp';
import { SelectableChip } from '../ui/SelectableChip';
import { PrimaryButton } from '../ui/PrimaryButton';
const HAZARD_OPTIONS = ['Working at height', 'Suspended load hazards', 'Struck-by hazards', 'Crane swing radius exposure', 'Dropped objects', 'Pinch points during positioning', 'Wind affecting load stability', 'Slips and trips in work zone'];
export function HazardIdentificationScreen({
  data,
  updateData,
  onNext
}: ScreenProps) {
  const handleToggle = (option: string) => {
    const current = data.selectedHazards;
    const updated = current.includes(option) ? current.filter(item => item !== option) : [...current, option];
    updateData({
      selectedHazards: updated
    });
  };
  return <div className="flex flex-col h-full" data-id="element-215">
      <div className="mb-6" data-id="element-216">
        <h2 className="text-2xl font-bold text-white mb-2" data-id="element-217">
          Hazard Identification
        </h2>
        <p className="text-slate-400" data-id="element-218">Select hazards relevant to the task.</p>
      </div>

      <div className="flex-1 overflow-y-auto pb-6 space-y-3 -mx-2 px-2" data-id="element-219">
        {HAZARD_OPTIONS.map(option => <SelectableChip key={option} label={option} selected={data.selectedHazards.includes(option)} onToggle={() => handleToggle(option)} icon={<AlertTriangleIcon className="w-5 h-5" data-id="element-221" />} data-id="element-220" />)}
      </div>

      <div className="pt-4" data-id="element-222">
        <PrimaryButton onClick={onNext} data-id="element-223">Continue</PrimaryButton>
      </div>
    </div>;
}